/*
* Main Menu height adjustments
* For each menu with 3 levels :
* - We target the level-2 menus and get the height of each <li> and sum it up
* - We then push the result into an array to compare them & then get the highest menu's Height
* - Then we apply the highest Height + paddings on the main Dropdown
* */

const mainMenu = document.querySelector('.js-main-menu');
const has3Levels = mainMenu.getElementsByClassName('has-3-levels');

window.addEventListener('load', () => {
  for (let i = 0; i < has3Levels.length; i++) {
    const el = has3Levels[i];
    const menuDropdown = el.querySelector('.menu-dropdown');
    menuDropdown.classList.add('js-dropdown-active');

    let level2Heights = [];
    const level2Menus = el.getElementsByClassName('level-2');

    for (let j = 0; j < level2Menus.length; j++) {
      const level2Menu = level2Menus[j];
      const items = level2Menu.getElementsByTagName('li');
      let cumulativeHeight = 0;
      level2Menu.classList.add('js-dropdown-active');

      for (let k = 0; k < items.length; k++) {
        const item = items[k];
        const itemHeight = parseFloat(item.offsetHeight);
        cumulativeHeight += itemHeight;
      }

      level2Menu.classList.remove('js-dropdown-active');
      level2Heights.push(cumulativeHeight);
    }

    const maxHeight = Math.max(...level2Heights);
    menuDropdown.style.minHeight = `${maxHeight + 72}px`; // Add top/bot padding
    menuDropdown.classList.remove('js-dropdown-active');
  }
});
